// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

/** OptionsSelector value for “create a new linked liquidity account”. */
export const BANK_UPLOAD_CREATE_LINKED_ACCOUNT_VALUE = '__create_new__';

export type LinkedLiquidityMode = 'none' | 'existing' | 'create';

export const getLinkedLiquidityMode = (
  selectorValue: string,
): LinkedLiquidityMode => {
  if (selectorValue === BANK_UPLOAD_CREATE_LINKED_ACCOUNT_VALUE) {
    return 'create';
  }

  if (selectorValue.trim() === '') {
    return 'none';
  }

  return 'existing';
};

export const toInstrumentIbanFromSelector = (selectorValue: string): string => {
  if (
    selectorValue === BANK_UPLOAD_CREATE_LINKED_ACCOUNT_VALUE ||
    selectorValue.trim() === ''
  ) {
    return '';
  }

  return selectorValue;
};
